import type { PriceGridFilterState } from './types';

export function getIsPriceGridFavoritesOnly(filterState: PriceGridFilterState) {
  return filterState.custom?.showFavoritesOnly === true;
}

export function getPriceGridFavoriteSymbolsFilter(filterState: PriceGridFilterState) {
  return (filterState.custom?.favoriteSymbols as string[] | undefined) ?? [];
}

export function setIsPriceGridFavoritesOnly(
  filterState: PriceGridFilterState,
  showFavoritesOnly: boolean,
  favoriteSymbols: string[] = []
) {
  return {
    ...filterState,
    custom: {
      ...filterState.custom,
      showFavoritesOnly: showFavoritesOnly ? true : undefined,
      favoriteSymbols: showFavoritesOnly ? favoriteSymbols : undefined,
    },
  };
}
